export default () => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    position: 'sticky',
    bottom: 0,
    background: 'white',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '24px 40px',
    borderTop: '1px solid rgba(89, 97, 104, 0.15)',
    marginTop: 40,
  },

  actions: {
    marginLeft: 'auto',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '& > *': {
      marginLeft: 10,
    },
  },

  secondaryActions: {
    marginRight: 'auto',
  },
});
